<template>
    <div class="nada-reservation-form" :class="is_hub ? 'hub-form' : ''">
        <div v-if="!is_hub" class="nada-reservation-form-title text-center">{{ store.brand?.reservation_heading || defaultHeading }}</div>
        <p v-if="!is_hub" class="text-center">{{ store.brand?.reservation_instructions || defaultInstructions }}</p>

        <form class="relative" :class="formIsLoading ? 'loading' : ''" @input="onAutoSave">
            <div class="loader loading-on"><span class="visuallyhidden">Loading</span></div>

            <div v-if="store.brand" class="loading-off">
                <div class="form-steps" :class="pageProducts.length > 1 ? '' : 'columns'">
                    <div class="form-step">
                        <div class="form-section">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group" :class="errors['FirstName'] ? 'error': ''" >
                                        <label class="control-label" for="FirstName">{{getTranslation('first_name')}}<span class="required">*</span></label>
                                        <input type="text" id="FirstName" name="FirstName" 
                                            v-model="reservationData.FirstName" 
                                        />
                                    </div>

                                    <span class="error-msg" v-if="errors['FirstName']">{{errors['FirstName']}}</span>
                                </div>

                                <div class="col-sm-6">
                                    <div class="form-group" :class="errors['LastName'] ? 'error': ''">
                                        <label class="control-label" for="LastName">{{getTranslation('last_name')}}<span class="required">*</span></label>
                                        <input type="text" id="LastName" name="LastName" v-model="reservationData.LastName" />
                                    </div>

                                    <span class="error-msg" v-if="errors['LastName']">{{errors['LastName']}}</span>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group" :class="errors['ContactEmail'] ? 'error': ''">
                                        <label class="control-label" for="ContactEmail">{{getTranslation('email')}}<span class="required">*</span></label>
                                        <input type="email" id="ContactEmail" name="ContactEmail" v-model="reservationData.ContactEmail" />
                                    </div>

                                    <span class="error-msg" v-if="errors['ContactEmail']">{{errors['ContactEmail']}}</span>
                                </div>

                                <div class="col-sm-6">
                                    <div class="form-group" :class="errors.Phone ? 'error': ''">
                                        <label class="control-label" for="Phone">
                                            {{getTranslation('phone')}}<span class="required">{{phoneRequired ? '*' : ''}}</span>
                                        </label>
                                        <input type="text" id="Phone" name="Phone" v-model="reservationData.Phone" @blur="cleanPhone" />
                                    </div>
                                    
                                    <span class="error-msg" v-if="errors.Phone">{{errors.Phone}}</span>
                                </div>
                            </div>
                        </div>

                        <div class="form-section form-section-light">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group" :class="errors.Zip ? 'error': ''">
                                        <label class="control-label" for="Zip">Zip<span class="required">*</span></label>
                                        <input type="text" id="Zip" name="Zip" v-model="reservationData.Zip" />
                                    </div> 

                                    <span class="error-msg" v-if="errors.Zip">{{errors.Zip}}</span>
                                </div>

                                <div class="col-sm-6">
                                    <div class="form-group" :class="errors['Company'] ? 'error': ''">
                                        <label class="control-label" for="Company">{{getBrandString('companyName')}}<span class="required">*</span></label>
                                        <input type="text" id="Company" name="Company" v-model="reservationData.Company" />
                                    </div>

                                    <span class="error-msg" v-if="errors['Company']">{{errors['Company']}}</span>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group" :class="errors.Title ? 'error': ''">
                                        <label class="control-label" for="Title">{{getTranslation('title')}}</label>
                                        <input type="text" id="Title" name="Title" v-model="reservationData.Title"  />
                                    </div>

                                    <span class="error-msg" v-if="errors.Title">{{errors.Title}}</span>
                                </div>
                            </div>

                            <div v-if="store.brand.brand_slug === 'dms-plus'" class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label class="control-label" for="ContractEndDate">Contract End Date</label>
                                        <input type="date" id="ContractEndDate" name="ContractEndDate" v-model="reservationData.ContractEndDate"  />
                                    </div>
                                </div>
                            </div>

                            <div v-if="store.brand.brand_slug === 'dms-plus'" class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label class="control-label" for="CurrentDMSProvider">Current DMS Provider</label>
                                        <input type="text" id="CurrentDMSProvider" name="CurrentDMSProvider" v-model="reservationData.CurrentDMSProvider"  />
                                    </div>
                                </div>
                            </div>

                            <div v-if="store.brand.brand_slug === 'wholesale-solutions'" class="row">
                                <div class="col-sm-12">
                                    <div class="form-group" :class="errors['fivemil'] ? 'error': ''">
                                        <label class="control-label" for="fivemil">5mill Number</label>
                                        <input type="number" id="fivemil" name="fivemil" v-model="reservationData.fivemil" min="0" max="999999" step="1" />
                                    </div>
        
                                    <span class="error-msg" v-if="errors['fivemil']">{{errors['fivemil']}}</span>
                                </div>
                            </div>
                        </div>

                        <div class="form-section" v-if="reservationData.RepId">
                            <div class="row">
                                <div class="col-sm-12">
                                    <label for="Comments">Comments</label>
                                    <div class="form-group" :class="errors['Comments'] ? 'error': ''">
                                        <textarea id="Comments" name="Comments" v-model="reservationData.Comments"></textarea>
                                    </div>
        
                                    <span class="error-msg" v-if="errors['Comments']">{{errors['Comments']}}</span>
                                </div>
                            </div>

                            <div class="row">
                                <div v-if="store.brand.brand_slug !== 'wholesale-solutions'" class="col-sm-6">
                                    <div class="form-group" :class="errors['CAID'] ? 'error': ''">
                                        <label class="control-label" for="CAID">CAID</label>
                                        <input type="text" id="CAID" name="CAID" v-model="reservationData.CAID" />
                                    </div>
        
                                    <span class="error-msg" v-if="errors['CAID']">{{errors['CAID']}}</span>
                                </div>
        
                                <div class="col-sm-6">
                                    <div class="form-group" :class="errors['repEmail'] ? 'error': ''">
                                        <label class="control-label" for="repEmail">Rep Email Address<span v-if="reservationData.RepId"><span class="required">*</span></span></label>
                                        <input type="text" id="repEmail" name="repEmail" v-model="reservationData.repEmail" />
                                    </div>
        
                                    <span class="error-msg" v-if="errors['repEmail']">{{errors['repEmail']}}</span>
                                </div>
                            </div>
                        </div>

                        <div v-if="store.brand.brand_slug !== 'wholesale-solutions' && !closeAttending" class="form-section">
                            <label for="willAttend">
                                {{reservationData.RepId ? getTranslation('willAttendRep') : getTranslation('willAttend')}}<span class="required">*</span>
                            </label>
        
                            <div class="radio-group horizontal">
                                <label class="radio-label alt" :class="reservationData.willAttend === true ? 'checked' : ''">
                                    <input type="radio" name="willAttend" :value="true" v-model="reservationData.willAttend" @change="switchWillAttend" />
                                    <span>Yes</span>
                                </label>
        
                                <label class="radio-label alt" :class="reservationData.willAttend === false ? 'checked' : ''">
                                    <input type="radio" name="willAttend" :value="false" v-model="reservationData.willAttend" @change="switchWillAttend" />
                                    <span>No</span>
                                </label>
                            </div>

                            <span class="error-msg" v-if="errors['willAttend']">{{errors['willAttend']}}</span>
                        </div>

                        <div v-if="store.brand.brand_slug === 'dms-plus' && reservationData.willAttend" class="form-section">
                            <label for="WhereDemo">Where should this demo take place?</label>
        
                            <div class="radio-group horizontal">
                                <label class="radio-label alt" :class="reservationData.WhereDemo === 'In a meeting room' ? 'checked' : ''">
                                    <input type="radio" name="WhereDemo" value="In a meeting room" v-model="reservationData.WhereDemo" />
                                    <span>In a meeting room</span>
                                </label>
        
                                <label class="radio-label alt" :class="reservationData.WhereDemo === 'At a booth station' ? 'checked' : ''">
                                    <input type="radio" name="WhereDemo" value="At a booth station" v-model="reservationData.WhereDemo" />
                                    <span>At a booth station</span>
                                </label>
                            </div>

                            <span class="error-msg" v-if="errors['willAttend']">{{errors['willAttend']}}</span>
                        </div>

                        <div v-if="store.brand.brand_slug === 'wholesale-solutions' && !closeAttending" class="form-section">
                            <label for="willAttend">
                                The Manheim 80th Anniversary gift is only available at NADA. Please confirm you will be at NADA to customize your gift.<span class="required">*</span>
                            </label>
        
                            <div class="radio-group">
                                <label class="radio-label alt white" :class="reservationData.willAttend === true ? 'checked' : ''">
                                    <input type="radio" name="willAttend" :value="true" v-model="reservationData.willAttend" @change="switchWillAttend" />
                                    <span>I am attending</span>
                                </label>
                                
                                <label class="radio-label alt white" :class="reservationData.willAttend === false ? 'checked' : ''">
                                    <input type="radio" name="willAttend" :value="false" v-model="reservationData.willAttend" @change="switchWillAttend" />
                                    <span>I am not attending but I would like to learn more</span>
                                </label>
                            </div>

                            <span class="error-msg" v-if="errors['willAttend']">{{errors['willAttend']}}</span>
                        </div>

                        <div v-if="store.brand.brand_slug === 'dt' && reservationData.willAttend === false" class="form-section">
                            <label>
                                What products would you like to demo with us? Select your state to see your solutions:
                            </label>
                        </div>


                        <div v-if="store.brand.show_city_state && reservationData.willAttend === false" class="form-section">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group" :class="errors.State ? 'error': ''">
                                        <label class="control-label" for="State">State<span class="required">*</span></label>
                                        <select id="State" name="State" v-model="reservationData.State" @change="switchState">
                                            <option v-for="state in states['us']" :value="state" :key="state">{{ state }}</option>
                                        </select>
                                    </div>

                                    <span class="error-msg" v-if="errors.State">{{errors.State}}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-step">
                        <div class="form-section form-section-tight">
                            <div v-if="
                                pageProducts.length > 1 && 
                                (
                                    (reservationData.willAttend === true && store.brand.has_goals) || 
                                    (reservationData.willAttend === false && store.brand.show_city_state && reservationData.State) || 
                                    (reservationData.willAttend === false && !store.brand.show_city_state)
                                )
                            ">
                                <div v-if="store.brand.brand_slug !== 'dt'">
                                    <label v-if="reservationData.willAttend && store.brand.has_goals && store.brand.brand_slug !=='retail'">What topics are you interested in?</label>
                                    <label v-else>What products would you like to demo with us?</label>
                                </div>

                                <div class="demo-checks" :class="errors['Demos'] ? 'error': ''">
                                    <div v-for="brand_slug in Object.keys(store.brand.brands)">
                                        <p v-if="!store.brand.brands[brand_slug].hide_brand_label && !store.brand.hide_brand_label" class="sub-cat">
                                            <strong>{{store.brand.brands[brand_slug].brand_name}}</strong>
                                            <small v-if="pageProducts.length > 1"><strong> ({{getTranslation('check_all')}})</strong></small>
                                        </p>

                                        <div class="checkbox-group" :class="(!store.brand.brands[brand_slug].hide_brand_label && !store.brand.hide_brand_label) ? 'breathe-mini' : ''">
                                            <strong v-if="!getBrandProductCount(brand_slug) && brand_slug !== 'dt-rts'">{{getBrandString('no_products')}}</strong>
                                            <span v-if="!getBrandProductCount(brand_slug) && brand_slug === 'dt-rts'">Registration & Title (In-state, Out-of-State, Trade-in Titling)</span>
                                            <div v-for="product in store.brand.brands[brand_slug].products" :key="product.ID">
                                                <label 
                                                    v-if="
                                                        (!product.restricted_states || product.restricted_states.indexOf(reservationData.State) >= 0) && 
                                                        (!product.restrict_to_all_states || (product.restrict_to_all_states && !reservationData.State)) &&
                                                        ((reservationData.willAttend && product.hide_from_not_attending) || (reservationData.willAttend === false && !product.hide_from_not_attending))
                                                    "
                                                    class="checkbox-label alt" 
                                                    :class="isProductSelected(product.ID, product.sf_brand || brand_slug) ? 'checked' : ''" 
                                                >
                                                    <input type="checkbox" 
                                                        name="selectedProducts"
                                                        :checked="isProductSelected(product.ID, product.sf_brand || brand_slug)"
                                                        @change="selectProduct(product, product.sf_brand || brand_slug)"
                                                    />
                                                    <span>
                                                        {{product.description ? product.description : product.title}}
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <span class="error-msg" v-if="errors['selections']">{{errors['selections']}}</span>
                                </div>
                            </div>

                            <div v-if="store.brand.show_recos_on_step_one && store.brand.recommended_brands.length && reservationData.willAttend">
                                <label>Which brands are you interested in?</label>
                                <div class="demo-checks">
                                    <div class="checkbox-group">
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <div v-for="brand in recoBrandsLeft" :key="brand.brand_value">
                                                    <label class="checkbox-label alt">
                                                        <input type="checkbox" 
                                                            name="selectedProducts"
                                                            v-model="reservationData['recommended_brands']"
                                                            :value="brand"
                                                        />
                                                        <span>{{brand.brand_name}}</span>
                                                    </label>
                                                </div>
                                            </div>

                                            <div class="col-sm-6">
                                                <div v-for="brand in recoBrandsRight" :key="brand.brand_value">
                                                    <label class="checkbox-label alt">
                                                        <input type="checkbox" 
                                                            name="selectedProducts"
                                                            v-model="reservationData['recommended_brands']"
                                                            :value="brand"
                                                        />
                                                        <span>{{brand.brand_name}}</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <span class="error-msg" v-if="errors['Brands']">{{errors['Brands']}}</span>
                                </div>
                            </div>

                            <div class="row" v-if="store.brand.brand_slug === 'man'">
                                <div class="col-sm-12">
                                    <div class="" :class="errors['ManheimMulti'] ? 'error': ''">
                                        <label class="" for="ManheimMulti">Do you rep multiple locations?</label>
                                        <label class="checkbox-label alt bg-white" :class="reservationData.ManheimMulti ? 'checked' : ''">
                                            <input type="checkbox" value="1" v-model="reservationData.ManheimMulti"/>
                                            Yes
                                        </label>
                                    </div>
        
                                    <span class="error-msg" v-if="errors['ManheimMulti']">{{errors['ManheimMulti']}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-step cdp-tracking">
                      <input type="hidden" name="cdp_annon_id" id="gform_cdp_annon_id" v-model="cdpAnnonId">
                      <input type="hidden" name="cdp_referrer_url" id="gform_cdp_referrer_url" value="">
                      <input type="hidden" name="cdp" id="gform_cdp" value="">
                      <input type="hidden" name="cdp_document_title" id="gform_cdp_document_title" v-model="cdpDocumentTitle">
                  </div>
                </div>

                <div class="form-section text-center">
                    <div class="breathe">
                        <div :class="formIsSubmitting ? 'loading' : ''">
                            <button type="button" class="btn btn-inline relative form-submit-button" v-on:click="submitForm($event)" >
                                <span class="loading-off">
                                    <span v-if="!closeAttending">{{(pageProducts.length > 1 || store.brand.is_umbrella) ? getBrandString('scheduleButton') : getBrandString('scheduleSingleButton')}}</span>
                                    <span v-if="closeAttending">Get a Demo</span>
                                    <span class="caret-right">&rsaquo;</span>
                                </span> 
                                <div class="loader loading-on"><span class="visuallyhidden">Loading</span></div>
                            </button>
                        </div>
                    </div>

                    <div v-if="Object.keys(errors).length" class="breathe">
                        <span class="error-msg large">{{getTranslation('validation_heading')}}</span>
        
                        <ul v-if="reservationData.language !== 'fr'" class="error-list">
                            <li v-if="key !== 'Mobile'" v-for="(value, key) in errors" :key="key" >{{
                                reservationData.validate && reservationData.validate.labels && reservationData.validate.labels[key] ? reservationData.validate.labels[key] : key
                            }}</li>
                        </ul>
                    </div>

                    <div v-if="recaptcha_error" class="breathe">
                        <span class="error-msg large">Could not submit form, please try again later.</span>
                    </div>

                    <SmsDisclaimer :hideSms="!reservationData.SMS_Opt_In" />

                    <div class="required-label breathe"><span class="required">*</span>{{getTranslation('required_fields')}}</div> 
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import "babel-polyfill";
    import Request from '../lib/atd-request.js';
    import ReservationData from '../reservation-data.js';
    import Validate from '../lib/atd-validate.js';
    import trackEvent from '../lib/atd-track-event.js';
    import { debounce } from '../lib/utils.js';
    import { VueReCaptcha, useReCaptcha } from 'vue-recaptcha-v3'

    import states from '../data/states.js';
    import brandStrings from '../data/brand-strings.js'
    import { getTranslation } from '../data/translations.js';
    import store from "../store/index.js";
    import SmsDisclaimer from "./SmsDisclaimer.vue";

    const API_URL = window.atdTradeshows.api_domain;

    export default {
        props: {},
        data() {
            return {
                store: store,
                pageProducts: [],
                reservationData: ReservationData.data,
                errors: {},
                formIsLoading: true,
                formIsSubmitting: false,
                SMS_Opt_In: false,
                states: states,
                getTranslation: getTranslation,
                autosaving: false,
                recaptcha: null,
                recaptcha_error: false,
                phoneRequired: false,
                cdpDocumentTitle: window.cdpParam?.postTitle || '',
                cdpName: 'coxinc_cdp',
                cdpAnnonId: localStorage.getItem( '__anon_id' )?.replace( /"/g, '' ) || '',
                cdpReferrerURL: document.referrer || '',
                defaultHeading: 'Reserve Your Seat',
                defaultInstructions: 'Fill out the form below',
                is_hub: false,
                closeAttending: false,
            }
        },
        components: {
            VueReCaptcha,
            SmsDisclaimer
        },
        computed: {
            recoBrandsLeft() {
                return store.brand.recommended_brands.slice(0, Math.ceil(store.brand.recommended_brands.length / 2));
            },

            recoBrandsRight() {
                return store.brand.recommended_brands.slice(Math.ceil(store.brand.recommended_brands.length / 2));
            }
        },
        mounted() {
            this.onAutoSave = debounce(() => this.getRecaptcha(true), 2000);

            let brandIdEl = document.querySelector('[data-nada-brand]');
            
            this.reservationData.brand_slug = brandIdEl?.dataset?.nadaBrand;

            this.phoneRequired = brandIdEl.dataset.phoneRequired ? true : false;

            this.reservationData.Campaign = brandIdEl.dataset.campaign || this.reservationData.Campaign;
            
            // utm params: get from gtm cookie or data attribute or default
            this.reservationData.UTM_source = brandIdEl.dataset.utm_source || this.getGTMCookieVal('__gtm_campaign_url', 'utm_source') ||  this.reservationData.UTM_source;
            this.reservationData.UTM_medium = brandIdEl.dataset.utm_medium || this.getGTMCookieVal('__gtm_campaign_url', 'utm_medium') || this.reservationData.UTM_medium;
            this.reservationData.UTM_content = brandIdEl.dataset.utm_content || this.getGTMCookieVal('__gtm_campaign_url', 'utm_content') || this.reservationData.UTM_content;
            this.reservationData.UTM_campaign = brandIdEl.dataset.utm_campaign || this.getGTMCookieVal('__gtm_campaign_url', 'utm_campaign') || this.reservationData.UTM_campaign;
            this.reservationData.UTM_term = brandIdEl.dataset.utm_term || this.getGTMCookieVal('__gtm_campaign_url', 'utm_term') || this.reservationData.UTM_term;

            this.reservationData.language = brandIdEl.dataset.language || this.reservationData.language;
            this.reservationData.ShowYear = brandIdEl.dataset.showyear || this.reservationData.ShowYear;
            this.reservationData.ShowName = brandIdEl.dataset.showname || this.reservationData.ShowName;
            this.reservationData.RepId = brandIdEl.dataset.repid || this.reservationData.RepId;
            this.SMS_Opt_In = brandIdEl.dataset.SMS_Opt_In || this.SMS_Opt_In;
            this.reservationData.tradeshowId = brandIdEl.dataset.tradeshowId || null;
            this.reservationData.ContactID = brandIdEl.dataset.contactid || this.reservationData.ContactID;
            this.reservationData.Country = brandIdEl.dataset.country || this.reservationData.Country;
            this.reservationData.FirstName = brandIdEl.dataset.firstname || this.reservationData.FirstName;
            this.reservationData.LastName = brandIdEl.dataset.lastname || this.reservationData.LastName;
            this.reservationData.ContactEmail = brandIdEl.dataset.contactemail || this.reservationData.ContactEmail;
            this.reservationData.State = brandIdEl.dataset.state || this.reservationData.State;
            this.reservationData.Zip = brandIdEl.dataset.zip || this.reservationData.Zip;
            this.reservationData.Company = brandIdEl.dataset.company || this.reservationData.Company;
            this.reservationData.Title = brandIdEl.dataset.title || this.reservationData.Title;
            if(typeof brandIdEl.dataset.willattend !== 'undefined') {
                this.reservationData.willAttend = brandIdEl.dataset.willattend === 'yes';
            }
            if(brandIdEl.dataset.closeAttending === '1') {
                this.reservationData.willAttend = false;
                this.closeAttending = true;
            }
            this.reservationData.audience = brandIdEl.dataset.audience || this.reservationData.audience;
            this.reservationData.UniformResourceIdentifier = window.location.href || this.reservationData.UniformResourceIdentifier;
            this.reservationData.CAID = brandIdEl.dataset.caid || this.reservationData.CAID;
            this.reservationData.fivemil = brandIdEl.dataset.fivemil || this.reservationData.fivemil;

            if(!this.reservationData.RepId) {
                this.reservationData.GlobalWebID = this.getCoxCookie('gwid') || this.reservationData.GlobalWebID;

                let gacid = '';
                try {
                    gacid = JSON.parse(this.getCoxCookie('gacid'))['cox-main'];
                } catch(e) {
                    gacid = '';
                }

                this.reservationData.GoogleAnalyticsClientID = gacid || this.reservationData.GoogleAnalyticsClientID;
                this.reservationData.BatchID = brandIdEl.dataset.batchid || this.reservationData.BatchID;
                this.reservationData.JobID = brandIdEl.dataset.jobid || this.reservationData.JobID;
            }
            else {
                this.reservationData.Dialed = true;
            }

            this.reservationData.cdp = {
              name: this.cdpName,
              annonID: this.cdpAnnonId,
              documentTitle: this.cdpDocumentTitle,
              referrerURL: this.cdpReferrerURL,
            }

            Request.get(`${API_URL}/wp-json/atd/nada-product/brand-detail/${this.reservationData.brand_slug}/${this.reservationData.tradeshowId}/${this.reservationData.audience}`).then((data) => {
                store.setBrand(JSON.parse(data));

                this.reservationData.BOI = store.brand.brand_of_interest;
                this.reservationData.Selling_BU = store.brand.brand_of_interest
                this.is_hub = store.brand.is_hub;

                this.pageProducts = Object.keys(store.brand.brands).map((key) => {
                    return store.brand.brands[key].products
                });
                this.pageProducts = [].concat.apply([], this.pageProducts);
                
                if(this.pageProducts.length === 1) { // pre select product when there is only one
                    this.selectProduct(this.pageProducts[0], this.pageProducts[0].brand_slug);
                }
                else { // select pre-selected products
                    Object.keys(store.brand.brands).forEach((brand_slug) => {
                        store.brand.brands[brand_slug].products.forEach((product) => {
                            if(product.preselect) {
                                this.selectProduct(product, brand_slug);
                            }
                        });
                    });
                }
            }).then(() => {
                this.formIsLoading = false;
                trackEvent(this.reservationData.ShowName, store.brand.brand_name, 'Landing Page');
            });

        },
        methods: {
            getBrandString: function(slug) {
                let brandedString = '';

                if(brandStrings[slug]) {
                    brandedString = brandStrings[slug][store.brand.brand_slug] ||  brandStrings[slug].default[this.reservationData.language] ||  brandedString;
                }

                return brandedString;
            },

            autoSave() {
                if(
                    this.autosaving || 
                    this.formIsSubmitting ||
                    !this.reservationData.FirstName ||
                    !this.reservationData.LastName ||
                    !this.reservationData.ContactEmail
                ) {
                    return;
                }

                this.autosaving = true;
                this.reservationData.status = 'pending';

                ReservationData.autoSave(this.reservationData, this.recaptcha).then((submission) => {
                    this.reservationData.pendingId = submission.submissionId;
                    this.reservationData.leadId = submission.leadId;

                    this.autosaving = false;
                });
            },

            submitForm: function(e) {
                e && e.preventDefault();

                if(this.formIsSubmitting) {
                    return;
                }
                this.formIsSubmitting = true;

                this.getRecaptcha();
            },

            scheduleDemos: function() {
                this.reservationData.status = 'submit';
                this.errors = Validate.validateData(this.reservationData, this.reservationData.validate.fields, this.reservationData.language);

                if(this.phoneRequired && !this.reservationData.Phone.length) {
                    this.errors = this.errors === true ? {} : this.errors;
                    this.errors.Phone = 'Missing Required Field';
                }

                if(
                    (this.reservationData.willAttend !== true && this.reservationData.willAttend !== false)
                ) {
                    this.errors = this.errors === true ? {} : this.errors;
                    this.errors.willAttend = 'Missing Required Field';
                }

                if(!this.reservationData.State && store.brand.show_city_state && this.reservationData.willAttend === false) {
                    this.errors = this.errors === true ? {} : this.errors;
                    this.errors.State = 'Please select a state';
                }

                if(this.reservationData.RepId && !Validate.validateEmail(this.reservationData.repEmail)) {
                    this.errors = this.errors === true ? {} : this.errors;
                    this.errors.repEmail = 'Valid rep email is required';
                }

                if(this.reservationData.fivemil !== '' &&  this.reservationData.fivemil > 999999) {
                    this.errors = this.errors === true ? {} : this.errors;
                    this.errors.fivemil = 'Maximum of 6 digits';
                }

                if(Object.keys(this.reservationData.selections).length === 0 && this.reservationData.willAttend === false) {
                    this.errors = this.errors === true ? {} : this.errors;
                    this.errors.selections = 'Please select at least one option.';
                }

                if(
                    store.brand.show_recos_on_step_one && 
                    store.brand.recommended_brands.length && 
                    this.reservationData['recommended_brands'].length === 0 && 
                    this.reservationData.willAttend
                ) {
                    this.errors = this.errors === true ? {} : this.errors;
                    this.errors.Brands = 'Please select at least one option.';
                }

                if(this.errors !== true) {
                    const width  = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                    if(width < 768) {
                        window.location.hash = 'nada-form';
                    }
                    this.formIsSubmitting = false;
                    return;
                }

                if(store.brand.fb_tracking_pixel && typeof fbq !== 'undefined') {
                    fbq('track', 'CompleteSignup', {content_name: 'schedule_demo'});
                }

                ReservationData.sendReservation(this.reservationData, this.recaptcha, false).then((submission) => {
                    if(submission === '"recaptcha_invalid"') {
                        this.recaptcha_error = true;
                        this.formIsSubmitting = false;
                        return;
                    }

                    this.reservationData.submissionId = submission.submissionId;

                });
            },

            selectProduct: function(product, brand_slug) {
                let selections = Object.assign({}, this.reservationData.selections);
                let real_brand_slug = product.sf_brand || brand_slug;

                selections[real_brand_slug] = selections[real_brand_slug] || {};
                selections[real_brand_slug].business_unit = store.business_unit;
                selections[real_brand_slug].products = selections[real_brand_slug].products || [];

                if(selections[real_brand_slug].products.indexOf(product) === -1) {
                    selections[real_brand_slug].products.push(product);
                }
                else {
                    selections[real_brand_slug].products = selections[real_brand_slug].products.filter((selection) => {
                        return product.ID !== selection.ID;
                    });

                    if(!selections[real_brand_slug].products || !selections[real_brand_slug].products.length) {
                        delete selections[real_brand_slug];
                    }
                }

                this.reservationData.selections = selections;
            },

            switchWillAttend: function() {
                this.reservationData.selections = {};

                if(this.reservationData.willAttend === false && this.pageProducts.length === 1) {
                    this.selectProduct(this.pageProducts[0], this.pageProducts[0].brand_slug);
                }
            },

            switchState: function() {
                let selections = Object.assign({}, this.reservationData.selections);

                Object.keys(selections).forEach((brand) => {
                    selections[brand].products = selections[brand].products.filter((product) => {
                        return (
                            (!product.restricted_states || product.restricted_states.indexOf(this.reservationData.State) >= 0) && 
                            (!product.restrict_to_all_states || (product.restrict_to_all_states && !this.reservationData.State))
                        );
                    });

                    
                    if(!selections[brand].products || !selections[brand].products.length) {
                        delete selections[brand].business_unit;
                        delete selections[brand];
                    }
                });

                this.reservationData.selections = selections;
            },

            getBrandProductCount(brand_slug) {
                let products = store.brand.brands[brand_slug].products.filter((product) => {
                    return (
                        (!product.restricted_states || product.restricted_states.indexOf(this.reservationData.State) >= 0) && 
                        (!product.restrict_to_all_states || (product.restrict_to_all_states && !this.reservationData.State))
                    )
                });
                
                return products.length;
            },

            /* Read utm params from GTM Cookie */
            getGTMCookieVal(cookie_name, term_name) {
                var match = document.cookie.match(new RegExp('(^| )' + cookie_name + '=([^;]+)'));
                if (!match || !match[2]) {
                    return null;
                }
                
                const gtm_url = decodeURIComponent(match[2]);
                const query = gtm_url.split('?');

                if(!query[1] || !URLSearchParams) {
                    return null;
                }

                const urlSearchParams = new URLSearchParams(query[1]);

                return urlSearchParams.get(term_name);
            },

            getCoxCookie(term) {
                const match = document.cookie.match(new RegExp('(^| )' + 'coxmkt' + '=([^;]+)'));
                if (!match || !match[2]) {
                    return null;
                }
                
                try {
                    const marketingObject = JSON.parse(decodeURIComponent(match[2]));
                    let value = marketingObject[term];
                    if(typeof value === 'object') {
                        value = JSON.stringify(value);
                    }

                    return value || '';
                } catch (error) {
                    console.error(error);
                    return '';
                }
            },

            isProductSelected(product_id, brand_slug) {
                return this.reservationData.selections[brand_slug] && 
                this.reservationData.selections[brand_slug].products &&
                    this.reservationData.selections[brand_slug].products.filter((product) => product.ID === product_id).length
            },

            async getRecaptcha(autosave = false) {
                this.recaptcha_error = false;

                await this.$recaptchaLoaded()

                // Execute reCAPTCHA with action "login".
                const token = await this.$recaptcha('login')

                if(token) {
                    this.recaptcha = token;
                    if(autosave) {
                        this.autoSave();
                    }
                    else {
                        this.scheduleDemos();
                    }
                }
                else {

                    this.recaptcha_error = true;
                    this.formIsSubmitting = false;
                }
            },

            cleanPhone() {
                this.reservationData.Phone = this.reservationData.Phone.replace(/-|\s/g, '');
            }
        },
    }
</script>
